import { render, staticRenderFns } from "./Configure.vue?vue&type=template&id=b0f53152&scoped=true"
import script from "./Configure.vue?vue&type=script&lang=js"
export * from "./Configure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f53152",
  null
  
)

export default component.exports